// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#NuSteps{margin:16px 0}`, "",{"version":3,"sources":["webpack://./src/shared/components/nu-steps/steps.component.scss"],"names":[],"mappings":"AAEA,SACI,aAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
